import { useState } from 'react';
import { Container, Typography, Tabs, Tab, Box } from '@mui/material';
import InsightsIcon from '@mui/icons-material/Insights';
import PeopleIcon from '@mui/icons-material/People';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import AnalyticsPanel from './admin/AnalyticsPanel';
import UsersPanel from './admin/UsersPanel';
import EmailPanel from './admin/EmailPanel';

export default function AdminDashboard() {
    const [tab, setTab] = useState('analytics');

    return (
        <Container maxWidth="lg" sx={{ pt: 6, pb: 8 }}>
            <Typography variant="h1" sx={{ color: 'text.primary', mb: 0.5 }}>
                Admin
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary', mb: 4 }}>
                User management and platform operations.
            </Typography>

            <Tabs
                value={tab}
                onChange={(_, v) => setTab(v)}
                sx={{
                    mb: 3,
                    borderBottom: t => `1px solid ${t.palette.custom.border.subtle}`,
                    minHeight: 40,
                    '& .MuiTab-root': { minHeight: 40, textTransform: 'none', fontWeight: 500 },
                }}
            >
                <Tab value="analytics" icon={<InsightsIcon sx={{ fontSize: 16 }} />}    iconPosition="start" label="Analytics" />
                <Tab value="users"     icon={<PeopleIcon sx={{ fontSize: 16 }} />}      iconPosition="start" label="Users" />
                <Tab value="email"     icon={<MailOutlineIcon sx={{ fontSize: 16 }} />} iconPosition="start" label="Email" />
            </Tabs>

            <Box hidden={tab !== 'analytics'}><AnalyticsPanel /></Box>
            <Box hidden={tab !== 'users'}><UsersPanel /></Box>
            <Box hidden={tab !== 'email'}><EmailPanel /></Box>
        </Container>
    );
}
